import React from 'react';
import { useTranslation } from 'react-i18next';
export const IncludedExamResults = ({ includedExams, language }) => {
    const { t } = useTranslation();
    const getExamDetailElements = (exam) => {
        const examDetails = exam.details[0];
        return (React.createElement("span", { key: examDetails.grade },
            React.createElement("b", null, examDetails.grade)));
    };
    return (React.createElement("div", { className: "examination-results" },
        React.createElement("table", null,
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { colSpan: 5 }, t('results.included_exams')))),
            React.createElement("tbody", null, includedExams.map(exam => (React.createElement("tr", { key: exam.examUuid },
                React.createElement("td", { className: "exam-code" }, exam.examDetailsYtlRegCode),
                React.createElement("td", { className: "exam-name" }, language === 'sv' ? exam.nameSwedish : exam.nameFinnish),
                React.createElement("td", { className: "exam-required" }),
                React.createElement("td", { className: "exam-gradecode" }, getExamDetailElements(exam)),
                React.createElement("td", { className: "exam-score" }),
                React.createElement("td", null,
                    React.createElement("span", { className: "exam-status" }),
                    React.createElement("span", { className: "exam-grade-points" }, exam.details[0].gradePoints)))))))));
};
//# sourceMappingURL=included-exam-result.js.map